import type { InputSource, IntentDispatch } from './intent';

// Keyboard scheme: ←/→ or -/+ change the answer, Space shoots, P/Esc pauses,
// E toggles reflections.
export class KeyboardInput implements InputSource {
  private dispatch: IntentDispatch | null = null;
  private readonly onKeyDown = (e: KeyboardEvent): void => {
    if (!this.dispatch) return;
    switch (e.key) {
      case 'ArrowRight': case '+': case '=':
        this.dispatch({ type: 'changeWeapon', delta: 1 }); break;
      case 'ArrowLeft': case '-': case '_':
        this.dispatch({ type: 'changeWeapon', delta: -1 }); break;
      case ' ': case 'Spacebar':
        e.preventDefault();
        this.dispatch({ type: 'shoot' }); break;
      case 'p': case 'P': case 'Escape':
        this.dispatch({ type: 'togglePause' }); break;
      case 'e': case 'E':
        this.dispatch({ type: 'toggleReflections' }); break;
      default:
        if (e.key >= '0' && e.key <= '9') {
          this.dispatch({ type: 'setWeapon', weapon: Number(e.key) });
        }
    }
  };

  attach(dispatch: IntentDispatch): void {
    this.dispatch = dispatch;
    window.addEventListener('keydown', this.onKeyDown);
  }

  detach(): void {
    window.removeEventListener('keydown', this.onKeyDown);
    this.dispatch = null;
  }
}
